var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#6B7AE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 31.7084C24.2555 31.7084 24.5005 31.6069 24.6812 31.4262C24.8619 31.2455 24.9635 31.0004 24.9635 30.7449V19.5813L29.099 23.7187C29.1886 23.8083 29.2949 23.8794 29.412 23.9279C29.529 23.9764 29.6545 24.0013 29.7812 24.0013C29.9079 24.0013 30.0333 23.9764 30.1504 23.9279C30.2674 23.8794 30.3738 23.8083 30.4634 23.7187C30.5529 23.6292 30.624 23.5228 30.6725 23.4058C30.721 23.2887 30.7459 23.1632 30.7459 23.0366C30.7459 22.9099 30.721 22.7844 30.6725 22.6674C30.624 22.5503 30.5529 22.444 30.4634 22.3544L24.6821 16.5731C24.5926 16.4834 24.4863 16.4122 24.3692 16.3636C24.2521 16.315 24.1267 16.29 23.9999 16.29C23.8732 16.29 23.7477 16.315 23.6306 16.3636C23.5136 16.4122 23.4072 16.4834 23.3177 16.5731L17.5365 22.3544C17.3556 22.5353 17.2539 22.7807 17.2539 23.0366C17.2539 23.2924 17.3556 23.5378 17.5365 23.7187C17.7174 23.8997 17.9628 24.0013 18.2187 24.0013C18.4745 24.0013 18.7199 23.8997 18.9009 23.7187L23.0364 19.5813V30.7449C23.0364 31.0004 23.1379 31.2455 23.3186 31.4262C23.4993 31.6069 23.7444 31.7084 23.9999 31.7084Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpButton);
export default __webpack_public_path__ + "static/media/up-button.ae387ec3c44f41f525fd21da82984b5c.svg";
export { ForwardRef as ReactComponent };